import { FC, useState } from "react";
import { Dialog } from "src/framework/components/commons/dialogs/Dialog";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { InputSwitch } from "src/framework/components/forms/inputs/InputSwitch";
import { notifierStore } from "src/framework/store/NotifierStore";
import { Verticais } from "../types";

export interface ProjetoSolicitacaoPausaDom extends Pick<Verticais, "id"> {
    solicitacao: string;
    envia_email: boolean;
    envia_email_interno: boolean;
}

export interface ProjetosSolicitacaoPausaProps {
    data: ProjetoSolicitacaoPausaDom | null;
    open: boolean;
    setOpen: (value: boolean) => void;
    applyConfirmation: (data: ProjetoSolicitacaoPausaDom) => void;
}

const ProjetosSolicitacaoPausaModal: FC<ProjetosSolicitacaoPausaProps> = ({ data, open, setOpen, applyConfirmation }) => {
    const [solicitacaoState, setSolicitacaoState] = useState<string>("");
    const [enviaEmailState, setEnviaEmailState] = useState<boolean>(false);
    const [enviaEmailInternoState, setEnviaEmailInternoState] = useState<boolean>(false);

    return (
        <Dialog
            key={`projetos-prioridade-modal-${data?.id}`}
            isOpen={open}
            title="Solicitação de Pausa do Projeto"
            onClose={() => setOpen(false)}
            content={
                <div className="row">
                    <div className="X12">
                        <InputText
                            multiline
                            label="Considerações"
                            fullWidth
                            maxRows={5}
                            minRows={2}
                            value={solicitacaoState}
                            InputProps={{
                                rows: 2
                            }}
                            onChange={(event: any) => {
                                setSolicitacaoState(event?.target?.value);
                            }}
                        />
                    </div>
                    <div className="X12">
                        <InputSwitch
                            margin="none"
                            label="Enviar e-mail com a considerações para REVENDA/DISTRIBUIDOR/PROFISSIONAL DE VENDAS"
                            value={enviaEmailState}
                            onChangeValue={(value) => {
                                setEnviaEmailState(value);
                            }}
                        />
                    </div>
                    <div className="X12">
                        <InputSwitch
                            margin="none"
                            label="Enviar e-mail com as considerações para BO/ENGENHARIA/PROFISSIONAL DE VENDAS"
                            value={enviaEmailInternoState}
                            onChangeValue={(value) => {
                                setEnviaEmailInternoState(value);
                            }}
                        />
                    </div>
                </div>
            }
            actions={
                [
                    {
                        color: "secondary",
                        label: "Fechar",
                        onClick: () => {
                            setOpen(false);
                        },
                    },
                    {
                        color: "primary",
                        label: "Confirmar",
                        onClick: () => {
                            if (!solicitacaoState) {
                                notifierStore.setNotifier({
                                    title: "Aviso!!!",
                                    content: ["Informe uma motivo/solicitação da pausa do projeto"],
                                    timeOut: 3500,
                                    onClose: () => {
                                        notifierStore.setOpen(false);
                                    }
                                });
                                notifierStore.setOpen(true);
                                return;
                            }

                            if (!data) {
                                return;
                            }

                            try {
                                const persistData: ProjetoSolicitacaoPausaDom = {
                                    id: data.id,
                                    solicitacao: solicitacaoState,
                                    envia_email: enviaEmailState,
                                    envia_email_interno: enviaEmailInternoState,
                                }

                                applyConfirmation(persistData);
                                setSolicitacaoState("");
                                setEnviaEmailState(false);
                                setEnviaEmailInternoState(false);
                            } finally {
                                setOpen(false);
                            }
                        },
                    },
                ]
            }
        >
        </Dialog>
    )
}

export { ProjetosSolicitacaoPausaModal }